<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { PrimaryButton, DialogConfirm } from '@es-bill/es-bill-common-components';
import ServiceFeeList from './ServiceFeeList.vue';
import ServiceFeeEditDialog from './ServiceFeeEditDialog.vue';

const { t } = useI18n();

// the page owning the subject (CP, CC or C) persists via its whole document
// update call and passes the current serviceFees array in
const props = defineProps({
  serviceFees: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['update:serviceFees']);

const editDialog = ref(false);
const editIndex = ref(-1);
const editFee = ref(null);

const deleteDialog = ref(false);
const deleteIndex = ref(-1);

function onAdd() {
  editIndex.value = -1;
  editFee.value = null;
  editDialog.value = true;
}

function onEdit(index) {
  editIndex.value = index;
  editFee.value = props.serviceFees[index];
  editDialog.value = true;
}

function onSave(fee) {
  const fees = props.serviceFees.slice();
  if (editIndex.value >= 0)
    fees[editIndex.value] = fee;
  else
    fees.push(fee);
  emit('update:serviceFees', fees);
}

function onRemove(index) {
  deleteIndex.value = index;
  deleteDialog.value = true;
}

function onRemoveConfirmed() {
  const fees = props.serviceFees.slice();
  fees.splice(deleteIndex.value, 1);
  deleteDialog.value = false;
  emit('update:serviceFees', fees);
}
</script>

<template>
  <div>
    <div class="d-flex justify-end mb-2">
      <PrimaryButton :text="t('serviceFees.addFee')" @click="onAdd" />
    </div>

    <ServiceFeeList
      :service-fees="serviceFees"
      @edit="onEdit"
      @remove="onRemove"
    />

    <ServiceFeeEditDialog
      v-model="editDialog"
      :fee="editFee"
      @save="onSave"
    />

    <DialogConfirm
      v-model="deleteDialog"
      :title="t('serviceFees.deleteFee')"
      :message="t('serviceFees.deleteFeeConfirm')"
      :confirmText="t('confirm')"
      :cancelText="t('cancel')"
      @confirm="onRemoveConfirmed"
      @cancel="deleteDialog = false"
    />
  </div>
</template>
